// extracted by mini-css-extract-plugin
export var content = "ContentfulComponentLogoBar-module--content--d0886";
export var image = "ContentfulComponentLogoBar-module--image--05b7f";
export var images = "ContentfulComponentLogoBar-module--images--b33e6";
export var section = "ContentfulComponentLogoBar-module--section--e5f0b";
export var trustpilot = "ContentfulComponentLogoBar-module--trustpilot--96630";